import { HttpClient, HttpResponse } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BaseService } from "projects/assist/src/app/_shared/services/base.service";
import { environment } from "projects/assist/src/environments/environment";
import { Observable, of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { AssistAuthService } from "../../auth/assist-auth.service";
import { Member, MemberPublic, MemberSimpleListDto, MemberStatus } from "../models/member";

@Injectable({
  providedIn: "root",
})
export class MemberService extends BaseService<Member, MemberPublic> {
  constructor(
    protected override http: HttpClient,
    @Inject("BASE_URL") protected override baseUrl: string,
    @Inject("PUBLIC_BASE_URL") private publicBaseUrl: string,
    private auth: AssistAuthService
  ) {
    super(http, baseUrl, "member");
  }

  save(member: MemberPublic, accessKey: string): Observable<HttpResponse<string>> {
    return this.http.post<HttpResponse<string>>(
      this.baseUrl + this.controller + "/public/" + accessKey,
      member
    );
  }

  getByKey(key: string, orgKey: string): Observable<MemberPublic> {
    return this.get("/public/" + key + "?organisationKey=" + orgKey);
  }

  getByKeyWithFallback(key: string, orgKey: string): Observable<MemberPublic | null> {
    return this.getByKey(key, orgKey).pipe(
      switchMap((member) => {
        if (member) {
          return of(member);
        } else if (this.auth.isLoggedIn) {
          return this.getByMemberKey(key);
        } else {
          return of(null);
        }
      })
    );
  }

  getValues(): Observable<MemberPublic> {
    let url = `${environment.apiUrl}/member/public/7c5ce89a-fa8b-4e36-b488-b02ed0cc5f96?organisationKey=707b788c-f486-4906-9dd3-4105c955006a`;
    return this.http.get<MemberPublic>(url);
  }

  getByKeyForReview(orgKey: string, accessKey: string): Observable<MemberPublic> {
    return this.get("/public/" + accessKey + "/forReview?organisationKey=" + orgKey);
  }

  getByMemberKey(memberKey: string): Observable<MemberPublic> {
    return this.http.get<MemberPublic>(this.publicBaseUrl + "member/accesskey/" + memberKey);
  }

  getAccessKeyByWaitinglistMemberAccessKey(key: string, orgKey: string): Observable<string> {
    return this.get<string>("/public/key/fromwaitinglist/" + key + "?organisationKey=" + orgKey);
  }

  pay(key: string, orgKey: string, returnUrl: string): Observable<string> {
    return this.http
      .get<string>(
        this.baseUrl +
          this.controller +
          "/public/" +
          key +
          "/pay?organisationKey=" +
          orgKey +
          "&returnUrl=" +
          returnUrl
      )
      .pipe(catchError(this.handleError<string>()));
  }

  getKeyByPerson(key: string, orgKey: string) {
    return this.get<string>("/public/keyByPerson/" + key + "?organizationKey=" + orgKey);
  }

  getAllNotPayed(exceptId: number): Observable<MemberSimpleListDto[]> {
    return this.getAll<MemberSimpleListDto>("/notPayed?exceptId=" + exceptId);
  }
  getFamilyMembersNotPayed(memberId: number): Observable<MemberSimpleListDto[]> {
    return this.get("/family/" + memberId + "/notpayed");
  }

  changeStatus(
    accessKey: string,
    organizationKey: string,
    statusId: MemberStatus,
    remark?: string
  ): Observable<boolean> {
    return this.patch<any, boolean>(
      `/public/${accessKey}/status?organisationKey=${organizationKey}`,
      {
        statusId: statusId,
        remark: remark,
      }
    );
  }
}
